var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSats(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white",
    fillOpacity: 0.06
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1042_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C24.8366 32 32 24.8366 32 16Z",
    fill: "white",
    fillOpacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6267 20.4965C23.1891 17.307 21.1252 15.8181 16.6914 14.5751C13.534 13.6434 13.023 12.8032 13.2481 11.5267C13.4732 10.2502 14.6943 9.62169 16.8391 9.99985C17.6218 10.0327 18.3797 10.3087 18.9707 10.776C19.5618 11.2435 19.9451 11.87 20.0492 12.5383C20.0812 12.6799 20.1627 12.812 20.2826 12.917C20.4025 13.0219 20.5553 13.0947 20.7199 13.1254L22.4356 13.4279C22.5345 13.4474 22.6358 13.4497 22.7335 13.4347C22.8312 13.4196 22.9232 13.3877 23.0038 13.3406C23.0846 13.2934 23.1521 13.2321 23.2027 13.1604C23.2534 13.0888 23.2859 13.0084 23.2984 12.9239L23.3145 12.833C23.2809 11.8091 22.8534 10.8043 22.0983 9.97465C21.3431 9.14505 20.3028 8.53713 19.1389 8.24545L19.5237 6.06335C19.5878 5.69967 19.3141 5.37024 18.7939 5.18477L17.1809 4.90034C16.7519 4.8247 16.3823 5.04071 16.1949 5.47641L15.8255 7.57119C14.4386 7.37298 13.0449 7.62697 11.9232 8.28225C10.8015 8.93745 10.0343 9.94577 9.77512 11.1055C9.24544 14.1096 11.1814 15.6735 15.6182 16.9245C18.5407 17.9086 19.4177 18.6293 19.1611 20.0841C18.9046 21.5388 17.2218 22.2771 15.18 21.9171C12.3874 21.4247 11.5946 20.2537 11.5139 18.8295C11.508 18.6737 11.4398 18.5213 11.3206 18.3979C11.2014 18.2744 11.0384 18.1874 10.8593 18.1515L9.032 17.8293C8.93312 17.8098 8.83176 17.8075 8.73408 17.8225C8.63648 17.8375 8.5444 17.8696 8.46376 17.9167C8.38304 17.9639 8.31552 18.0252 8.26488 18.0968C8.21424 18.1685 8.1816 18.2491 8.16912 18.3335L8.15312 18.4243C8.14472 19.6358 8.63208 20.8356 9.5312 21.816C10.4302 22.7963 11.6842 23.4955 13.0758 23.7923L12.691 25.9743C12.6269 26.338 12.9006 26.6675 13.4207 26.853L15.0335 27.1374C15.4625 27.2131 15.8323 26.997 16.0198 26.5612L16.4045 24.3792C17.8613 24.5263 19.3001 24.212 20.4473 23.4961C21.5945 22.7803 22.3702 21.7127 22.6267 20.4965Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1042_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSats);
export default __webpack_public_path__ + "static/media/SATS.1db34e73632fc09ea94d7c897ffaa0db.svg";
export { ForwardRef as ReactComponent };